<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search') ||
                  '产品SKU编号/NC产品编号/产品企划名称/产品名称/产品颜色/品牌名称/SKU-新编号/内部编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      :modal-append-to-body="false"
      :modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        label-position="left"
        size="small"
      >
        <el-row :gutter="20">
          <!-- <el-col :span="24">
            <el-form-item
              :label="$l('form_label_applicationStatus') || '申请状态'"
            >
              <el-checkbox-group v-model="form.listApplicationStatus">
                <el-checkbox label="P">
                  {{ $l('form_label_applicationStatus_p') || '提交转正申请' }}
                </el-checkbox>
                <el-checkbox label="R">
                  {{ $l('form_label_applicationStatus_r') || '转正申请驳回' }}
                </el-checkbox>
                <el-checkbox label="M">
                  {{ $l('form_label_applicationStatus_m') || '转正申请通过' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$l('form_label_hxSkuStatus') || '产品状态'">
              <el-checkbox-group v-model="form.listHxSkuStatus">
                <el-checkbox label="Q">
                  {{ $l('INDEX.form_label_amzSkuStatus_q') || '企划' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_amzSkuStatus_y') || '正式产品' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('INDEX.form_label_amzSkuStatus_d') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_amzSkuNo') || '产品SKU编号'"
            >
              <el-input
                v-model.trim="form.hxSkuNo"
                :placeholder="
                  $l('INDEX.form_placeholder_amzSkuNo') || '请输入产品SKU编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_ncNo') || 'NC产品编号'">
              <el-input
                v-model.trim="form.ncNo"
                :placeholder="
                  $l('INDEX.form_placeholder_ncNo') || '请输入NC产品编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_Spuno') || 'SPU编号'">
              <el-input
                v-model.trim="form.hxSpuNo"
                :placeholder="
                  $l('INDEX.form_placeholder_SpuNo') || '请输入SPU编号'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_brand') || '品牌'"
              prop="brandCode"
            >
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/spuBrandSelect"
                :placeholder="
                  $l('INDEX.form_placeholder_brand') || '请选择品牌'
                "
                clearable
                filterable
                style="width:100%"
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('INDEX.table_label_succession') || '系列'">
              <dict-select
                v-model="form.listCollectionNo"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('INDEX.form_label_selectseries') || '请选择系列'
                "
                :body="collectionParams"
                clearable
                filterable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.table_label_category') || '分类'">
              <el-cascader
                :options="categoryTree"
                :props="{
                  emitPath: false,
                  checkStrictly: false,
                  value: 'value',
                  label: 'label',
                }"
                ref="cascaderCategoryTreeRef"
                v-model="form.detailCategoryCode"
                clearable
                filterable
                style="width: 100%"
                :showAllLevels="false"
                @change="onCategoryChange"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
            >
              <el-input
                v-model.trim="form.goodsName"
                :placeholder="
                  $l('INDEX.form_placeholder_goodsNameCn') || '请输入中文名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_goodsNameEn') || '英文名称'"
            >
              <el-input
                v-model.trim="form.goodsNameEn"
                :placeholder="
                  $l('INDEX.form_placeholder_goodsNameEn') || '请输入英文名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_goodsColorCn') || '中文颜色'"
            >
              <el-input
                v-model.trim="form.goodsColor"
                :placeholder="
                  $l('INDEX.form_placeholder_goodsColorCn') || '请输入产品颜色'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_goodsColorEn') || '英文颜色'"
            >
              <el-input
                v-model.trim="form.goodsColorEn"
                :placeholder="
                  $l('INDEX.form_placeholder_goodsColorEn') || '请输入产品颜色'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.form_label_production_order_goods_pattern') || '花型'
              "
            >
              <el-input
                v-model.trim="form.goodsPattern"
                :placeholder="
                  $l('INDEX.tips_goods_label_orderGoodsPattern') || '请输入花型'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_table_label_goods_style') || '款式'"
            >
              <el-input
                v-model.trim="form.goodsStyle"
                :placeholder="
                  $l('INDEX.tips_goods_label_goodsStyle') || '请输入款式'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_design') || '企划人员'">
              <dict-select
                v-model="form.listDesignCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_placeholder_design') || '请选择企划人员'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_label_buyer') || '采购人员'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_placeholder_buyer') || '请选择采购人员'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_createDate') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modifyDate') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.isVc') || '是否VC产品'">
              <el-checkbox-group v-model="form.listIsVc">
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_needInspection_y') || '是' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('INDEX.form_label_needInspection_n') || '否' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.eanCode') || 'EAN条码'">
              <el-input
                v-model.trim="form.eanCode"
                :placeholder="$l('INDEX.tips_input_eanCode') || '请输入EAN条码'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listHxSkuStatus: ['Q', 'Y'],
  listIsVc: [],
  listApplicationStatus: [],
}
export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
      collectionParams: { dictType: 'skuCollection' },
      categoryTree: [],
    }
  },
  mounted() {
    this.query()
    this.getTreeData()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
      if (nodes?.length && nodes[0] && nodes[0].path?.length) {
        this.formData.displayCategoryCode = nodes[0].path.join(',')
        this.formData.masterCategoryCode = nodes[0].path[0]
      } else {
        this.formData.displayCategoryCode = null
        this.formData.masterCategoryCode = null
      }
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
